import { Award,Shop,Truck,Notepad2,Send ,WalletMoney,MobileProgramming,ReceiptText,ShoppingBag,HomeTrendUp,NoteAdd,MoneySend,Book,TaskSquare,Setting2,DocumentText,Image,Gallery} from 'iconsax-react';

import IntlMessages from "../../layout/components/lang/IntlMessages";

const pages = [
    {
        header: <IntlMessages id="sidebar-pages" />,
        
    },

   
    {
        id: "Secretaria",
        title: <IntlMessages id="secretaria" />,
        icon: <NoteAdd size={18} />,
        navLink: "/pages/secretaria",
        permissions: ["secretaria"],
        
    },
    {
        id: "midia",
        title: <IntlMessages id="midia" />,
        icon: <NoteAdd size={18} />,
        navLink: "/pages/midia",
        permissions: ["midia"],
        
    },
    {
        id: "cibe",
        title: <IntlMessages id="Cibe" />,
        icon: <NoteAdd size={18} />,
        navLink: "/pages/cibe",
        permissions: ["cibe"],
        
    },
    {
        id: "Phd",
        title: <IntlMessages id="Phd" />,
        icon: <NoteAdd size={18} />,
        navLink: "/pages/phd",
        permissions: ["phd"],
        
    },
    {
        id: "juca",
        title: <IntlMessages id="juca" />,
        icon: <NoteAdd size={18} />,
        navLink: "/pages/juca",
        permissions: ["juca"],
        
    },
    {
        id: "kids",
        title: <IntlMessages id="kids" />,
        icon: <NoteAdd size={18} />,
        navLink: "/pages/kids",
        permissions: ["kids"],
        
    },
    
    {
        id: "Administrativo",
        title: <IntlMessages id="Administrativo" />,
        icon: <HomeTrendUp size={18} />,
        navLink: "/pages/Administrativo",
        permissions: ["administrativo"]
    },
    
    {
        header: "Configurações do Site",
    },
    
    {
        id: "configuracoes-site",
        title: "Configurações do Site",
        icon: <Setting2 size={18} />,
        permissions: ["administrativo", "editor"],
        children: [
            {
                id: "editar-sobre",
                title: "Editar Sobre",
                navLink: "/pages/editar-sobre",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "editar-home",
                title: "Editar Home",
                navLink: "/pages/editar-home",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "editar-tesouraria",
                title: "Editar Tesouraria",
                navLink: "/pages/editar-tesouraria",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "igrejas",
                title: "Igrejas",
                navLink: "/pages/igrejas",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "documentos",
                title: "Documentos",
                navLink: "/pages/documentos",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "departamentos",
                title: "Departamentos",
                navLink: "/pages/departamentos",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "diretoria",
                title: "Diretoria",
                navLink: "/pages/diretoria",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "midias",
                title: "Mídias",
                navLink: "/pages/midias",
                permissions: ["administrativo", "editor"],
            },
            {
                id: "instagram-fotos",
                title: "Fotos Instagram",
                navLink: "/pages/instagram-fotos",
                permissions: ["administrativo", "editor"],
            },
        ],
    },
    
];

export default pages